module.exports = __webpack_public_path__ + "img/BoardNotJoin.2f0eac53.svg";